import { Injectable } from '@angular/core';
import { OnDemandType } from 'src/app/domains/on-demand/data/on-demand.model';
import { SurveyIntervention } from './survey.model';

@Injectable({
  providedIn: 'root'
})
export class InterventionService {
  private readonly INTERVENTION_KEY = 'survey_intervention_';

  constructor() {}

  setIntervention(intervention: SurveyIntervention | null, type: OnDemandType = 'mind'): void {
    if (intervention) {
      localStorage.setItem(this.INTERVENTION_KEY + type, JSON.stringify(intervention));
    } else {
      localStorage.removeItem(this.INTERVENTION_KEY + type);
    }
  }

  getIntervention(type: OnDemandType): SurveyIntervention | null {
    const key = this.INTERVENTION_KEY + type;
    const stored = localStorage.getItem(key);

    if (!stored) {
      return null;
    }

    try {
      return JSON.parse(stored);
    } catch (error) {
      console.error('Failed to parse intervention data from localStorage:', error);
      localStorage.removeItem(key);

      return null;
    }
  }
}
